/*
 * Copyright(c) 2022 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */
import { Component, HostListener } from '@angular/core';
import { Logger } from '@core/lib/services';
import { ModalConfig, ModalRef } from '@core/public-api';
import { ConfigData } from '../../data-model/config-data';

const log = new Logger('RecordManagementComponent');

@Component({
  selector: 'record-management',
  styleUrls: [],
  templateUrl: './record-management.component.html'
})
export class RecordManagementComponent {
  private data: ConfigData;
  editExam: boolean;
  editPatient: boolean;

  private userActivity;

  constructor(public config: ModalConfig, private modalRef: ModalRef) {}

  ngOnInit(): void {
    if (this.config && this.config.data) {
      this.data = this.config.data;
      this.editExam = this.data.selectedOption === 'editExam';
      this.editPatient = this.data.selectedOption === 'editPatient';

      // Close the modal if user is inactive
      this.setInterval();
    }
  }

  @HostListener('window:mousemove') refreshUserState() {
    if (this.userActivity) {
      clearInterval(this.userActivity);
      this.setInterval();
    }
  }

  setInterval() {
    this.userActivity = setInterval(() => {
      log.warn('Closing Record Management window due to user inactivity of ' + this.data.timeoutEditLockHold + ' ms');
      this.userActivity = undefined;
      this.modalRef.close();
    }, this.data.timeoutEditLockHold);
  }
}
